import { useState, useMemo } from "react";
import { ArrowLeftRight, TrendingUp, TrendingDown } from "lucide-react";
import { filterTransactions, formatTRY, formatInt } from "../data/mock";

export default function HavaleFast() {
  const [method, setMethod] = useState("all");
  const rows = useMemo(
    () => filterTransactions({ method: method === "all" ? "all" : method }).filter((t) => ["Havale", "FAST"].includes(t.method) || method === "all"),
    [method]
  );
  const list = method === "all" ? filterTransactions({}).filter((t) => ["Havale", "FAST"].includes(t.method)) : filterTransactions({ method });
  const havale = list.filter((t) => t.method === "Havale");
  const fast = list.filter((t) => t.method === "FAST");
  const sum = (arr) => arr.reduce((a, t) => a + t.amount, 0);

  return (
    <div className="space-y-5" data-testid="page-havale-fast">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <ArrowLeftRight className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Havale / FAST</h1>
          <p className="text-xs text-slate-500">Banka transfer işlemleri</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-white dark:bg-[#151824] rounded-2xl p-5 shadow-sm border border-slate-100 dark:border-slate-800">
          <div className="flex items-center justify-between">
            <span className="font-bold">Havale</span>
            <span className="text-xs text-slate-400">{formatInt(havale.length)} işlem</span>
          </div>
          <div className="text-2xl font-extrabold text-[#F0651E] mt-2">{formatTRY(sum(havale))}</div>
        </div>
        <div className="bg-white dark:bg-[#151824] rounded-2xl p-5 shadow-sm border border-slate-100 dark:border-slate-800">
          <div className="flex items-center justify-between">
            <span className="font-bold">FAST</span>
            <span className="text-xs text-slate-400">{formatInt(fast.length)} işlem</span>
          </div>
          <div className="text-2xl font-extrabold text-[#F0651E] mt-2">{formatTRY(sum(fast))}</div>
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div className="overflow-x-auto max-h-[520px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-white dark:bg-[#151824]">
              <tr className="text-left text-[13px] font-bold text-violet-600 dark:text-violet-400 border-b border-slate-100 dark:border-slate-800">
                <th className="px-6 py-3">BAYİ</th>
                <th className="px-4 py-3">TÜR</th>
                <th className="px-4 py-3">YÖNTEM</th>
                <th className="px-4 py-3 text-right">MİKTAR</th>
                <th className="px-4 py-3">BANKA</th>
                <th className="px-6 py-3 text-right">TARİH</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {list.slice(0, 150).map((r) => (
                <tr key={r.id} className="hover:bg-slate-50 dark:hover:bg-slate-800/50">
                  <td className="px-6 py-3 font-bold">{r.bayiId}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center gap-1 font-semibold ${r.type === "yatirim" ? "text-green-600" : "text-red-500"}`}>
                      {r.type === "yatirim" ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
                      {r.type === "yatirim" ? "Yatırım" : "Çekim"}
                    </span>
                  </td>
                  <td className="px-4 py-3">{r.method}</td>
                  <td className="px-4 py-3 text-right font-bold">{formatTRY(r.amount)}</td>
                  <td className="px-4 py-3 text-slate-500">{r.bank}</td>
                  <td className="px-6 py-3 text-right text-slate-500 whitespace-nowrap">{r.dateStr}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
